export default function IconSearch() {
  return (
    <svg
      id="icon_pesquisar"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Caminho_4311"
        data-name="Caminho 4311"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Caminho_4312"
        data-name="Caminho 4312"
        d="M18.031,16.617,22.314,20.9,20.9,22.314l-4.282-4.283a9,9,0,1,1,1.414-1.414Zm-2.006-.742a7,7,0,1,0-.15.15l.15-.15Z"
        fill="#959595"
      />
    </svg>
  );
}
